var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBoxUpdate({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 20,
    viewBox: "0 0 17 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.24316 0.0683594C8.40133 -0.0244752 8.59786 -0.0225193 8.75488 0.0722656L16.7588 4.90723C16.9084 4.99774 16.9999 5.16012 17 5.33496V15.0254C16.9999 15.2088 16.8987 15.3776 16.7373 15.4648L8.97559 19.6611C8.67884 19.8216 8.32116 19.8216 8.02441 19.6611L0.262695 15.4648C0.101332 15.3776 0.000139108 15.2088 0 15.0254V5.49023C2.96341e-05 5.13592 0.18778 4.80759 0.493164 4.62793L8.24316 0.0683594ZM4 10.5713H6.28613V14H10.8574V10.5713H13.1426L8.57129 6L4 10.5713Z",
    fill: "#14AC63"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoxUpdate);
export default __webpack_public_path__ + "static/media/BoxUpdate.a0fc3d2c909670d458ecccc4e8bf751b.svg";
export { ForwardRef as ReactComponent };